import styled from 'styled-components';

export const Container = styled.div`
  width: fit-content;
  min-width: 940px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  color: #007ade;
`;

export const HeaderTitle = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
  align-items: center;
`;

export const Icon = styled.span`
  grid-area: icon;
`;

export const Title = styled.b`
  grid-area: title;
  font-family: Poppins;
  font-weight: 500;
  font-style: Medium;
  font-size: 26px;
  color: #212121;
`;

export const Description = styled.span`
  grid-column: 1 / -1;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #616161;
`;

export const ContainerContent = styled.div`
  position: relative;
  width: 980px;
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 30px;
  padding: 20px;
  width: 980px;
  height: fit-content;
  border-radius: 13px;
  background-color: #f8f8f8;
`;

InfoContainer.Text = styled.div`
  font-family: Poppins;
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  line-height: 1.7;
  color: #212121;

  svg {
    transform: translateY(5px);
  }
`;

InfoContainer.Title = styled.div`
  display: flex;
  gap: 10px;
  font-family: Poppins;
  font-weight: 500;
  font-style: Medium;
  font-size: 26px;
  line-height: 1.4;
  color: #8e8e8e;
  padding-bottom: 10px;

  svg {
    transform: translateY(6px);
  }
`;

InfoContainer.CloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 20px;

  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: #6c757d;
  border-radius: 4px;
  transition: background-color 0.2s;
  margin-left: auto;

  &:hover {
    background-color: #e9ecef;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const InfoToggleButton = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  transition: opacity 0.2s;
  font-family: Poppins;
  font-weight: 500;
  font-style: Medium;
  font-size: 16px;
  color: #8e8e8e;

  &:hover {
    opacity: 0.7;
  }
`;
